const API_URL = process.env.REACT_APP_API_URL;

export const uploadFile = async (file, onProgress) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const formData = new FormData();
        formData.append('file', file);

        xhr.upload.addEventListener('progress', event => {
            if (event.lengthComputable && onProgress) {
                const percentCompleted = Math.round((event.loaded * 100) / event.total);
                const progress = percentCompleted > 90 ? 90 : percentCompleted;
                onProgress(progress);
            }
        });

        xhr.addEventListener('load', () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    onProgress(100);
                    const response = JSON.parse(xhr.responseText);
                    resolve(response);
                } catch (error) {
                    reject(new Error('Invalid JSON response'));
                }
            } else {
                try {
                    const errorResponse = JSON.parse(xhr.responseText);
                    reject(new Error(errorResponse.error || 'Upload failed'));
                } catch (error) {
                    reject(new Error('Upload failed'));
                }
            }
        });

        xhr.addEventListener('error', () => {
            reject(new Error('Upload failed'));
        });

        xhr.open('POST', `${API_URL}/api/files/upload`, true);
        xhr.withCredentials = true;
        xhr.send(formData);
    });
};

export const getFileUrl = (url) => {
    if (url.startsWith('/')) {
        return `${API_URL}${url}`;
    }
    return url;
};
